exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{margin:0}.container{width:100vw;max-width:1280px;margin:auto}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./src/style.scss
 ** module id = 288
 ** module chunks = 0
 **/